export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/Cure.91a60432.svg","height":101,"width":126,"blurWidth":0,"blurHeight":0};